/*
 * AI1 WORLD - Wishlist server sync (cross-device)
 * Bridges the local wishlist (window.AI1WL) with the Shopify App Proxy backend
 * so a logged-in customer's list follows them across devices.
 *
 * Behaviour:
 *   - On load (logged in): PULL the server list, merge with the local list,
 *     save the merged list locally, then PUSH the merged union back up.
 *   - On every change: debounce, then PUSH the current list.
 *   - Guests (not logged in) are ignored here; the local per-device list still
 *     works, and it merges into the account on first login (handled by core).
 *
 * Install: upload as assets/ai1-wishlist-sync.js and load it AFTER
 * ai1-wishlist.js and ai1-wishlist-cart.js (see the loader line in the README).
 */
(function () {
  'use strict';

  var A = window.AI1WL;
  if (!A) return;                         // core must be loaded first
  if (window.ai1Customer == null) return; // only sync for logged-in customers

  var PROXY = '/apps/my-wishlist';        // your App Proxy sub-path
  var DEBOUNCE_MS = 800;
  var suppress = false;                   // don't echo our own hydration write back up
  var timer;

  // Union of two lists, de-duplicated by product handle (order preserved).
  function mergeByHandle(a, b) {
    var out = [], seen = {};
    [a, b].forEach(function (list) {
      (list || []).forEach(function (it) {
        if (it && it.handle && !seen[it.handle]) { seen[it.handle] = 1; out.push(it); }
      });
    });
    return out;
  }

  function pull() {
    return fetch(PROXY, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.ok && Array.isArray(d.items)) ? d.items : null; })
      .catch(function () { return null; });
  }

  function push(items) {
    return fetch(PROXY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).catch(function () {});
  }

  function schedulePush() {
    if (suppress) return;
    clearTimeout(timer);
    timer = setTimeout(function () { push(A.read()); }, DEBOUNCE_MS);
  }

  // Initial reconcile: merge server <-> local, save locally, push the union.
  function reconcile() {
    pull().then(function (serverItems) {
      var local = A.read();
      if (serverItems == null) { push(local); return; }  // server unreachable -> at least push local
      var merged = mergeByHandle(local, serverItems);
      suppress = true;      // the write below fires ai1:wishlist:change; don't re-push from it
      A.write(merged);      // updates localStorage + refreshes hearts/drawer/page
      suppress = false;
      push(merged);         // make sure the server holds the full union too
    });
  }

  document.addEventListener('ai1:wishlist:change', schedulePush);
  reconcile();
})();
